import { renderAssemblySheet } from "./assembly-sheet.js";
import type { PosterPdfAssets } from "./poster-pdf.js";
import { loadGlueStickPng, renderScissorsPng } from "./sheet-marks.js";
import type { AssemblyInfo, PaperOrientation, PaperSize } from "./types.js";

/** Browser-side bitmaps the poster PDF builder embeds (instruction page, marks). */
export async function loadPosterPdfAssets(
  info: AssemblyInfo,
  sheet: PaperSize,
  orientation: PaperOrientation,
): Promise<PosterPdfAssets> {
  const [assembly, scissorsPng, gluePng] = await Promise.all([
    renderAssemblySheet({ info, paper: sheet, orientation, pixelRatio: 2 }),
    renderScissorsPng(),
    loadGlueStickPng(),
  ]);
  return { assemblyPng: assembly.pngBytes, scissorsPng, gluePng };
}
